var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 27H0V93H70V27Z",
    fill: "#FC6A46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0797 31C58.0733 31 57.0896 31.2931 56.2534 31.842C55.4172 32.391 54.7661 33.171 54.3828 34.0832C53.9995 34.9954 53.9013 35.9986 54.1006 36.9656C54.2998 37.9327 54.7875 38.8199 55.5019 39.5148C56.2163 40.2097 57.1252 40.6808 58.1132 40.8686C59.1011 41.0563 60.1237 40.9522 61.0512 40.5693C61.9787 40.1864 62.7693 39.5421 63.3227 38.7181C63.8761 37.8941 64.1674 36.9275 64.1595 35.941C64.1491 34.627 63.6093 33.3703 62.6577 32.4448C61.7062 31.5193 60.4201 31 59.0797 31ZM55.2401 54.7219H58.3276L75.0581 31.2328H72.0234L55.2401 54.7219ZM71.1789 45.0469C70.4909 45.0125 69.803 45.1156 69.1569 45.35C68.5109 45.5844 67.9202 45.9452 67.4208 46.4104C66.9215 46.8756 66.5239 47.4355 66.2521 48.0561C65.9804 48.6766 65.8403 49.3449 65.8403 50.0202C65.8403 50.6956 65.9804 51.3638 66.2521 51.9843C66.5239 52.6049 66.9215 53.1649 67.4208 53.6301C67.9202 54.0953 68.5109 54.456 69.1569 54.6904C69.803 54.9248 70.4909 55.0279 71.1789 54.9935C72.4797 54.9285 73.7053 54.3762 74.6025 53.4506C75.4997 52.5251 76 51.297 76 50.0202C76 48.7434 75.4997 47.5154 74.6025 46.5899C73.7053 45.6643 72.4797 45.1119 71.1789 45.0469Z",
    fill: "#16161E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 68H42V18.2471L65.9936 3L90 18.2471V68Z",
    stroke: "#16161E",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 20C67.433 20 69 18.433 69 16.5C69 14.567 67.433 13 65.5 13C63.567 13 62 14.567 62 16.5C62 18.433 63.567 20 65.5 20Z",
    stroke: "#16161E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterest);
export default __webpack_public_path__ + "static/media/interest.eb57338854f7b8a4c96c569584ca3560.svg";
export { ForwardRef as ReactComponent };